var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page"},[_c('data-table-v2',{staticClass:"mt-2pert px-0",attrs:{"title":"Transactions","fields":_vm.txs.fields,"pagination":_vm.txs.pagination,"loadItems":_vm.loadTxs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }